<template>
  <transaction-period-mam-sub></transaction-period-mam-sub>
</template>

<script>
import transactionPeriodMamSub from '@/components/user/details/mamSub/overview/transactionPeriod/transactionPeriodMamSub'
export default {
  name: "index",
  components: {
    transactionPeriodMamSub,
  }
}
</script>

<style scoped>

</style>
